import type { IntlShape } from "@formatjs/intl";
import { Button, Result } from "antd";
import React from "react";

type ResourceErrorResultProps = {
	status: number;
	intl: IntlShape;
	onGoToDashboard: () => void;
	onGoBack: () => void;
};

const messageKeyByHttpStatus: Record<number, string> = {
	403: "forbidden",
	404: "not_found",
};

export const ResourceErrorResult = React.memo(
	(props: ResourceErrorResultProps) => {
		const { status, intl, onGoToDashboard, onGoBack } = props;
		const messageKey = messageKeyByHttpStatus[status] ?? "generic";
		return (
			// Text only: the "403"/"404"/"500" statuses would force antd's illustration regardless of `icon`
			<Result
				icon={null}
				title={intl.formatMessage({ id: `page_error_${messageKey}_title` })}
				subTitle={intl.formatMessage({
					id: `page_error_${messageKey}_subtitle`,
				})}
				extra={[
					<Button type="primary" key="dashboard" onClick={onGoToDashboard}>
						{intl.formatMessage({ id: "page_error_go_to_dashboard" })}
					</Button>,
					<Button key="back" onClick={onGoBack}>
						{intl.formatMessage({ id: "page_error_go_back" })}
					</Button>,
				]}
			/>
		);
	},
);
